import { render } from "./PokemonDetail.vue?vue&type=template&id=cffd13a8&scoped=true"
import script from "./PokemonDetail.vue?vue&type=script&lang=js"
export * from "./PokemonDetail.vue?vue&type=script&lang=js"

import "./PokemonDetail.vue?vue&type=style&index=0&id=cffd13a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cffd13a8"]])

export default __exports__